import { Reducer } from "redux";

import { ConversionsAction, ConversionsActionTypes, ConversionsState } from "./types";

const initialState: ConversionsState = {
  count: 0,
  items: [],
  dataIsLoading: false,
  summaryIsLoading: false,
  chartItems: [],
  chartDataIsLoading: false,
  chartSearchResultsItems: [],
  chartSearchResultsDataIsLoading: false,
};

const reducer: Reducer<ConversionsState, ConversionsAction> = (state = initialState, action) => {
  switch (action.type) {
    case ConversionsActionTypes.TABLE_FETCH_REQUEST:
      return { ...state, dataIsLoading: true };

    case ConversionsActionTypes.TABLE_SUMMARY_FETCH_REQUEST:
      return { ...state, summaryIsLoading: true };

    case ConversionsActionTypes.TABLE_FETCH_ERROR:
      return { ...state, dataIsLoading: false };

    case ConversionsActionTypes.TABLE_SUMMARY_FETCH_ERROR:
      return { ...state, summaryIsLoading: false };

    case ConversionsActionTypes.TABLE_FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, dataIsLoading: false, items: results };
    }

    case ConversionsActionTypes.TABLE_SUMMARY_FETCH_SUCCESS:
      return { ...state, summary: action.payload, summaryIsLoading: false };

    case ConversionsActionTypes.CHART_FETCH_REQUEST: {
      return { ...state, chartDataIsLoading: true };
    }

    case ConversionsActionTypes.CHART_FETCH_SUCCESS: {
      const { items } = action.payload;
      return { ...state, chartDataIsLoading: false, chartItems: items };
    }

    case ConversionsActionTypes.CHART_FETCH_ERROR: {
      return { ...state, chartDataIsLoading: false };
    }

    case ConversionsActionTypes.CHART_SEARCH_RESULTS_FETCH_REQUEST: {
      return { ...state, chartSearchResultsDataIsLoading: true };
    }
    case ConversionsActionTypes.CHART_SEARCH_RESULTS_FETCH_SUCCESS: {
      const { items } = action.payload;
      return { ...state, chartSearchResultsDataIsLoading: false, chartSearchResultsItems: items };
    }
    case ConversionsActionTypes.CHART_SEARCH_RESULTS_FETCH_ERROR: {
      return { ...state, chartSearchResultsDataIsLoading: false };
    }

    default:
      return state;
  }
};

export default reducer;
